import { classes } from '@services/MarppleShop/shared/util';
import { html, View } from 'rune-ts';
import klass from './CreatorProfile.module.scss';

export interface CreatorProfileProps {
  profile_url?: string | null;
  size?: 'large' | 'medium' | 'small';
  no_border?: boolean;
}

export class CreatorProfile extends View<CreatorProfileProps> {
  static default_creator_profile =
    'https://s3.marpple.co/files/u_1165777/2024/4/original/8ff2b4e88ce4d2eabce1474c26a20de0220d2d981.png';

  override template() {
    const { profile_url, size, no_border } = this.data;
    const klasses = classes({
      [klass.no_border]: no_border,
      [klass.container]: true,
      [klass[size ?? 'medium']]: true,
    });

    return html`
      <div class="${klasses}">
        <img
          class="${klass.profile_image}"
          src="${profile_url || CreatorProfile.default_creator_profile}"
          alt="creator profile"
        />
      </div>
    `;
  }

  toggleTransparent(on: boolean) {
    if (on) {
      this.element().classList.add(klass.transparent);
    } else {
      this.element().classList.remove(klass.transparent);
    }
  }
}
